export abstract class AppError extends Error {
  abstract readonly code: string;
  abstract readonly isOperational: boolean;

  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}
